module.exports = __webpack_public_path__ + "media/images/etyekilogo-etyeki-152x152-7083453c6b330a1448109fe5b515ebc6.png";